import React from "react";
import "./AiButton.css";
import { Trigger } from "@activecollab/components";
import PropTypes from "prop-types";

export const AiButton = ({ children, onClick, disabled, className, id }) => {
  return (
    <Trigger
      onClick={onClick}
      disabled={disabled}
      className={className}
      id={id}
    >
      <div className="gradient-button">
        <span className="tw-flex tw-items-center tw-gap-1.5 tw-text-theme-700 tw-fill-theme-700">{children}</span>
      </div>
    </Trigger>
  );
};

AiButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};
